const TAG_COLUMNS_ORG_TAG_KEY = "cpln/console.tagColumns";

/**
 * Parses the org tag value for `cpln/console.tagColumns` into a mapping
 * of resource type to tag name arrays.
 *
 * Format: "workload=bu,su,o,iki;gvc=mytag,yourtag"
 *   - `;` separates resource type sections
 *   - `=` separates resource type from tag names
 *   - `,` separates tag names within a section
 */
export function parseTagColumnsConfig(value: string | undefined | null): Record<string, string[]> {
  if (!value || typeof value !== "string") {
    return {};
  }

  const result: Record<string, string[]> = {};

  const sections = value.split(";");
  for (const section of sections) {
    const trimmed = section.trim();
    if (!trimmed) continue;

    const eqIndex = trimmed.indexOf("=");
    if (eqIndex < 1) continue;

    const resourceType = trimmed.slice(0, eqIndex).trim();
    const tagNamesCsv = trimmed.slice(eqIndex + 1).trim();

    if (!resourceType || !tagNamesCsv) continue;

    const tagNames = tagNamesCsv
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

    if (tagNames.length > 0) {
      result[resourceType] = tagNames;
    }
  }

  return result;
}

export { TAG_COLUMNS_ORG_TAG_KEY };
